<!--
 * @Author: wjl
 * @Date: 2021-02-18 09:21:17
 * @LastEditors: hxz
 * @LastEditTime: 2023-08-11 18:53:23
 * @FilePath: \appOfficial\src\views\SdkPage.vue
-->
<template>
  <div class="contrainer">
    <h2>第三方SDK收集使用信息说明</h2>
    <p>
      为保障网上老年大学App相关功能的实现与应用安全稳定的运行，我们接入的第三方SDK主要服务于您以及其他用户的需求，因此在满足新的服务需求及业务功能变更时，我们会调整我们接入的第三方SDK。我们会及时在本说明中向您公开第三方SDK的最新情况。
    </p>
    <dl>
      <h3>一、 登录类服务SDK</h3>
      <dt>SDK名称：阿里云</dt>
      <dt>使用目的：号码认证服务，安卓热修复</dt>
      <dt>
        个人信息类型：网络类型、设备信息（含IP地址、设备制造商、设备型号、手机操作系统、SIM卡信息SIM
        State、SIM卡信息ICCID）。
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a href="https://help.aliyun.com/document_detail/84541.html">
          https://help.aliyun.com/document_detail/84541.html
        </a>
      </dt>
    </dl>

    <dl>
      <h3>二、社交类服务SDK</h3>
      <dt>SDK名称：微信开放平台</dt>
      <dt>使用目的：接入微信开放平台SDK，微信分享和微信支付及拉起小程序</dt>
      <dt>
        数据类型：设备信息（IMEI/MAC/Android
        ID/IDFA/OpenUDID/GUID/SIM卡IMSI/地理位置/存储文件等。
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a
          href="https://open.weixin.qq.com/cgi-bin/index?t=home/index&lang=zh_CN"
        >
          https://open.weixin.qq.com/cgi-bin/index?t=home/index&lang=zh_CN
        </a>
      </dt>
    </dl>

    <dl>
      <h3>三、推送通知类服务SDK</h3>
      <dt>SDK名称：腾讯云</dt>
      <dt>公司名称：腾讯科技（深圳）有限公司</dt>
      <dt>使用目的： 即时通信IM 、云直播</dt>
      <dt>
        个人信息类型：设备型号，系统属性，Wi-Fi 状态，IP
        地址，相机，录音，传感器信息，电池状态，蓝牙等等，自启动用于精准接收推送消息。
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a href="https://cloud.tencent.com/document/product/301/11470">
          https://cloud.tencent.com/document/product/301/11470
        </a>
      </dt>
      <br />
      <!-- ---------------------------------------------- -->
      <dt>SDK名称：华为 HMS push</dt>
      <dt>使用目的：推送消息</dt>
      <dt>
        数据类型：应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息和系统设置信息
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a
          href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/privacy-statement-0000001050042021"
        >
          https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/privacy-statement-0000001050042021
        </a>
      </dt>
      <br />
      <!-- ------------------------------------------------ -->
      <dt>SDK名称：魅族 Flyme push</dt>
      <dt>使用目的：推送消息</dt>
      <dt>
        数据类型：设备标识符（如IMEI、Serial）、MAC地址、位置信息（如GPS）、WLAN接入点（如SSID、BSSID）
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a href="http://static.meizu.com/resources/term/privacy8.html">
          http://static.meizu.com/resources/term/privacy8.html
        </a>
      </dt>
      <br />
      <!-- ------------------------------------------------- -->
      <dt>SDK名称：OPPO push</dt>
      <dt>使用目的： 推送消息</dt>
      <dt>
        数据类型：设备标识符（如IMEI、OAID、Serial、IMSI、Android
        ID、GAID）、应用信息、网络信息、IP地址、设备信息
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a href="https://open.oppomobile.com/new/developmentDoc/info?id=10288">
          https://open.oppomobile.com/new/developmentDoc/info?id=10288
        </a>
      </dt>
      <br />
      <!-- -------------------------------------------------- -->
      <dt>SDK名称：vivo push</dt>
      <dt>使用目的： 推送消息</dt>
      <dt>
        数据类型：设备信息
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a href="https://dev.vivo.com.cn/documentCenter/doc/652#w1-12075822">
          https://dev.vivo.com.cn/documentCenter/doc/652#w1-12075822
        </a>
      </dt>
      <br />
      <!-- -------------------------------------------------- -->
      <dt>SDK名称：小米 MiPush</dt>
      <dt>使用目的：推送消息</dt>
      <dt>
        数据类型：设备标识符（如Android
        ID、OAID）、应用信息、设备信息、网络信息（本地处理）
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a href="https://dev.mi.com/distribute/doc/details?pId=1534">
          https://dev.mi.com/distribute/doc/details?pId=1534
        </a>
      </dt>
      <br />
      <!-- -------------------------------------------------- -->
      <dt>SDK名称：腾讯信鸽</dt>
      <dt>使用目的： 推送消息</dt>
      <dt>
        数据类型：设备标识符（如Android
        ID、OAID）、应用信息、设备信息、网络信息（本地处理）
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a href="https://cloud.tencent.com/product/tpns">
          https://cloud.tencent.com/product/tpns
        </a>
      </dt>
    </dl>

    <dl>
      <h3>四、统计分析类服务SDK</h3>
      <dt>SDK名称：腾讯移动分析SDK</dt>
      <dt>使用目的：用于统计页面打开时间以及次数</dt>
      <dt>
        个人信息类型：设备信息（IMEI/MAC/Android
        ID/IDFA/OpenUDID/GUID/SIM卡IMSI/地理位置等。）
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a href="https://privacy.qq.com/policy/tencent-privacypolicy">
          https://privacy.qq.com/policy/tencent-privacypolicy
        </a>
      </dt>
      <br />
      <!-- ------------------------------------ -->
      <dt>SDK名称：Umeng（友盟） SDK</dt>
      <dt>使用目的：统计分析</dt>
      <dt>
        个人信息类型：设备信息（IMEI/MAC/Android
        ID/IDFA/OpenUDID/GUID/SIM卡IMSI/地理位置等。）
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a href="https://www.umeng.com/page/policy">
          https://www.umeng.com/page/policy
        </a>
      </dt>
      <br />
      <!-- -------------------------------------- -->
      <dt>SDK名称：神策数据</dt>
      <dt>使用目的：统计分析</dt>
      <dt>
        个人信息类型：设备信息（包括IMEI、Android
        ID、IDFA、IDFV、OAID、UUID、Mac地址、IMSI信息等）、日志信息（包括IP地址、访问服务的URL、浏览器类型和使用语言等）、位置信息、唯一应用程序编号。
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a
          href="https://manual.sensorsdata.cn/sa/latest/tech_sdk_client-1573786.html"
        >
          https://manual.sensorsdata.cn/sa/latest/tech_sdk_client-1573786.html
        </a>
      </dt>
    </dl>

    <dl>
      <h3>五、地图定位类服务SDK</h3>
      <dt>SDK名称：腾讯地图</dt>
      <dt>使用目的：用于展示地图</dt>
      <dt>
        个人信息类型：硬件型号、操作系统版本、唯一设备标识符（ICCID、IMSI、IMEI、UUID）、设备连接信息以及设备状态信息、Mac地址，IDFA，设备标识符。
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a href="https://lbs.qq.com/map/"> https://lbs.qq.com/map/ </a>
      </dt>

      <br />
      <dt>SDK名称：腾讯定位</dt>
      <dt>使用目的：帮助用户发布信息时定位位置</dt>
      <dt>
        个人信息类型：设备信息（OAID，设备型号，运营商基站信息（Cell
        id），WIFI信息，传感器信息，蓝牙信息，GPS信息，IP地址）。
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a href="https://lbs.qq.com/"> https://lbs.qq.com/ </a>
      </dt>
    </dl>

    <dl>
      <h3>六、其它类服务SDK</h3>
      <dt>SDK名称：微盟</dt>
      <dt>使用目的：嵌入微商城</dt>
      <dt>
        个人信息类型：包括设备型号、操作系统版本、设备设置、
        唯一设备标识符、设备环境等软硬件特征信息、设备所在位置相关信息包括您授权的
        GPS 位置以及 WLAN 接入点、蓝牙和基站等传感器信息。
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a
          href="http://cloud.weimob.com/saas/word/detail.html?tag=1079&menuId=2"
        >
          http://cloud.weimob.com/saas/word/detail.html?tag=1079&menuId=2
        </a>
      </dt>
      <br />
      <dt>SDK名称：Openinstall</dt>
      <dt>使用目的：H5拉起App 、获取安装渠道、粘贴板信息跳转指定页面</dt>
      <dt>
        个人信息类型：SDK版本、应用程序版本、应用程序包名、IP地址（确定所在城市）、设备品牌、设备型号、设备操作系统版本、Android
        ID、设备序列号（SerialNumber）、设备传感器（传感器数量）、本地存储权限，为开发者展示多维度的统计信息、收集(获取粘贴板信息)。
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a href="https://www.openinstall.io/privacy.html">
          https://www.openinstall.io/privacy.html
        </a>
      </dt>

      <br />
      <dt>SDK名称：Bugly</dt>
      <dt>
        使用目的：用于监测APP稳定性并进行故障诊断、崩溃上报，以便帮助用户快速解决异常情况
      </dt>
      <dt>
        个人信息类型：日志信息（包括：第三方开发者自定义日志、Logcat 日志以及
        APP 崩溃堆栈信息）、设备 ID（包括：androidid
        以及idfv）、联网信息、系统名称、系统版本以及国家码。
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a
          href="https://bugly.qq.com/docs/user-guide/instruction-manual-android/?v=20180312155926"
        >
          https://bugly.qq.com/docs/user-guide/instruction-manual-android/?v=20180312155926
        </a>
      </dt>

      <br />
      <dt>SDK名称：啄木鸟SDK</dt>
      <dt>
        使用目的：用于APP线上质量监控以及生成崩溃日志、异常定位分析服务，以便帮助用户快速解决异常情况
      </dt>
      <dt>
        个人信息类型：外部文件存储目录信息、日志信息（包括：第三方开发者自定义日志、Logcat
        日志以及 APP 崩溃堆栈信息）、设备 ID（包括：androidid
        以及idfv）、联网信息、系统名称、系统版本以及国家码。
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a href="http://open-uc.uc.cn/solution/zhuomuniao">
          http://open-uc.uc.cn/solution/zhuomuniao
        </a>
      </dt>

      <br />
      <dt>SDK名称：淘宝开放平台SDK</dt>
      <dt>使用目的：批量调用请求，减少网络请求次数</dt>
      <dt>
        个人信息类型：包括设备型号、操作系统版本、设备设置、
        唯一设备标识符、设备环境等软硬件特征信息。
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a
          href="https://open.taobao.com/v2/doc#/abilityToOpen?treeId=713&docType=1&docId=104350"
        >
          https://open.taobao.com/v2/doc#/abilityToOpen?treeId=713&docType=1&docId=104350
        </a>
      </dt>

      <br />
      <dt>SDK名称：乐播云SDK</dt>
      <dt>使用目的：用于提供客户端内视频投屏功能</dt>
      <dt>
        个人信息收集方式：采集设备信息（包括设备名称、设备型号、设备品牌、设备服务商、硬件序列号、Android ID、软件安装列表、SIM卡序列号、MAC地址、Wifi Mac 地址、OAID、IMEI、IMSI、IDFA、DIFV、设备ID、应用进程列表、操作系统及软件版本、设备状态、网络状况）、上网记录、日志信息、IP地址、位置信息、剪贴板内容信息
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a
          href="https://www.lebo.cn/mobile/privacy.html"
        >
          https://www.lebo.cn/mobile/privacy.html
        </a>
      </dt>


      <br />
      <dt>SDK名称：实时音视频 TRTC SDK</dt>
      <dt>使用目的：提供实时音视频通信服务，主要场景包括音视频通话、在线会议、在线课堂、互动直播等</dt>
      <dt>
        个人信息收集方式：Wi-Fi 状态、系统属性、设备型号、操作系统、IP 地址、相机、录音、传感器信息
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a
          href="https://cloud.tencent.com/document/product/647/57574"
        >
          https://cloud.tencent.com/document/product/647/57574
        </a>
      </dt>

      <br />
      <dt>SDK名称：腾讯云对象存储SDK（COS SDK）</dt>
      <dt>使用目的：提供高效、安全、低成本的云存储服务，支持文件、图片、音视频等多种类型数据的存储与访问，广泛应用于网站、移动应用、大数据、人工智能等多种场景。</dt>
      <dt>
        个人信息收集方式：设备型号、操作系统版本（用于兼容性检查）、Wi-Fi状态（影响数据传输速度）、用于日志记录、安全审计及访问控制、记录用户通过SDK执行的操作，如上传、下载、删除文件等，但不包含敏感个人信息
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a
          href="https://cloud.tencent.com/document/product/301/103169"
        >
          https://cloud.tencent.com/document/product/301/103169
        </a>
      </dt>

      <br />
      <dt>SDK名称：移动应用微信登录SDK</dt>
      <dt>使用目的：用于提供移动应用内的微信账号快速、安全登录功能，简化用户注册和登录流程，提升用户体验。</dt>
      <dt>
        数据类型：设备名称、设备型号、设备品牌、操作系统及版本等基本信息，以确保SDK的兼容性和稳定性。
      </dt>
      <dt>
        <span>SDK官网：</span>
        <a
          href="https://open.weixin.qq.com/cgi-bin/index?t=home/index&lang=zh_CN"
        >
          https://open.weixin.qq.com/cgi-bin/index?t=home/index&lang=zh_CN
        </a>
      </dt>


    </dl>
  </div>
</template>

<script>
export default {
  name: "sdkPage",
  data() {
    return {};
  },
  mounted() {
    window.scroll(0, 0);
  },
  methods: {
    to(url) {
      window.location = url;
    },
  },
};
</script>

<style lang="scss" scoped>
.contrainer {
  padding: 30px;
  color: black;
  overflow-x: auto;
}

h2 {
  text-align: center;
}

p {
  margin: 20px 0;
}
</style>
